// Combine-segments feature constants.

// Defaults live in the dataviz layer; re-exported so the config form can't drift.
export { DEFAULT_MAX_SEGMENTS } from "@/components/dataviz/PieChart";

// Minimum visible segments the stepper allows.
export const MIN_SEGMENTS = 1;
